import initialState from './initialState';
import { reducer as chartsService } from './chartsService';
import { reducer as labelsService } from './labelsService';
import {
  reducer as updateChartForToggledSarcasticCommentOrTweetService,
} from './updateChartForToggledSarcasticCommentOrTweetService';
import {
  reducer as updateChartForRelevanceUpdatesOfCommentOrTweet,
} from './updateChartForRelevanceUpdatesOfCommentOrTweetService';
import {
  reducer as updateChartForRelevanceUpdatesOfPost,
} from './updateChartForRelevanceUpdatesOfPostService';
const reducers = [
  chartsService, 
  labelsService, 
  updateChartForToggledSarcasticCommentOrTweetService,
  updateChartForRelevanceUpdatesOfCommentOrTweet,
  updateChartForRelevanceUpdatesOfPost
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/shared-components/chart/redux/reducer.js